exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "html[dir] .BzMImhgQV2EOmRRKpgJ8M{padding:0}html[dir=ltr] ._2SkVtzLLeg3BNxqJg3sYio{padding-left:20px}html[dir=rtl] ._2SkVtzLLeg3BNxqJg3sYio{padding-right:20px}html[dir=ltr] ._3VJyREcZCIhpjIV_xJpAjy{margin-left:20px}html[dir=rtl] ._3VJyREcZCIhpjIV_xJpAjy{margin-right:20px}", ""]);
// Exports
exports.locals = {
	"insightsContainer": "BzMImhgQV2EOmRRKpgJ8M",
	"insightsContent": "_2SkVtzLLeg3BNxqJg3sYio",
	"relatedContentHeaderSubText": "_3VJyREcZCIhpjIV_xJpAjy"
};